export const mobileMq = '@media screen and (max-width: 960px)';
